import { email, maxLength, regex, required } from '@vfde-brix/ws10/validation';

export const INPUT_LENGTH_50 = 50;
export const INPUT_LENGTH_10 = 10;
export const INVALID_CHARS_REGEX = /\?|=|\(|\)|"|§|\$|%/g;

export const getRequiredValidation = (errorKey = 'required') => ({
    validator: required,
    errorKey,
});

export const getEmailValidation = () => ({
    validator: email,
    errorKey: 'email',
});

export const getMaxLengthValidation = (value = INPUT_LENGTH_50, errorKey = 'maxLength') => ({
    validator: maxLength,
    errorKey: errorKey,
    maxLength: value,
});

export const getInvalidCharsValidation = () => ({
    validator: regex,
    errorKey: 'invalidCharacters',
    regex: INVALID_CHARS_REGEX,
});
